export default __webpack_public_path__ + "static/media/methodology-4-step.853096af.svg";